<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <h2 class="card-title-desc">Incomplete Deliveries</h2>
          <TableLoading v-if="orders.page === 0"/>
          <div v-else>
            <data-table :columns="columns" :rows="orders.objects" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn">
              <template v-slot:actions="slotProps" v-if="checkForPermission(change_order_status_permission)">
                <div class="button-items">
                  <b-button v-if="slotProps.row.canCancelOrder && checkForPermission(cancel_order_permission)" variant="danger" size="sm" class="py-1 text-white" @click="cancelOrder(slotProps.row.publicId)">
                    Cancel Order
                  </b-button>
                  <b-button variant="primary" size="sm" class="py-1 text-white" @click="markAsDelivered(slotProps.row.publicId)">
                    Mark as Delivered
                  </b-button>
                </div>
              </template>
            </data-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="orders.total"
                :per-page="perPage"
                size="lg"
                align="center"
                class="mt-3"
            />
          </div>

        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import DataTable from "@/components/data-table";
import {ALL_CUSTOMER_ORDERS_DELIVERIES} from "@/gql/orders";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";

export default {
  page: {
    title: "Incomplete Deliveries",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, PageHeader, Layout},
  name: "incomplete-deliveries",
  data() {
    return {
      title: "Incomplete Deliveries",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Incomplete Deliveries",
          active: true
        }
      ],
      change_order_status_permission: permissions.change_order_status_permission,
      cancel_order_permission: permissions.cancel_order_permission,
      orders: {
        page: 0,
        objects: []
      },
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      loadedIds: ['b3180af8-62c8-44ce-8432-64c02c5e5a56'], //loaded
      columns: [
        {
          field: 'customer.customerCode',
          label: 'Customer Code'
        },
        {
          field: 'customer.name',
          label: 'Customer Name'
        },
        {
          field: 'invoiceId',
          label: 'Order'
        },
        {
          field: 'createdAt',
          label: 'Order Date'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'orderTimeZone',
          label: 'Timezone'
        },
        {
          field: 'orderStatus',
          label: 'Status'
        },
        {
          field: 'actions',
          label: 'Actions'
        },
      ]
    }
  },
  apollo: {
    orders: {
      query: ALL_CUSTOMER_ORDERS_DELIVERIES,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword,
          orderStatus: this.loadedIds
        }
      }
    }
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      changeOrderStatus: 'orders/changeOrderStatus',
    }),
    async markAsDelivered(orderId){
      const data = {orderId: orderId ,statusId: "601fdbd6-c437-4758-98a2-e807e847f566"}
      await this.changeOrderStatus(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.orders.refetch()
        }
      })
    },
    async cancelOrder(orderId){
      const data = {orderId: orderId ,statusId: "c518ae7e-0732-46cb-b234-da118cdfd8f9"}
      await this.changeOrderStatus(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.orders.refetch()
        }
      })
    },
    searchFn(data){
      this.searchKeyword = data
    }
  }
}
</script>

<style scoped>

</style>
